import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { CampaniaDescuentoDestino } from '../_models/campania-descuento-destino';

@Injectable({
  providedIn: 'root'
})
export class CampaniaDescuentoDestinoService {

  private rutServicioCampania = AppSettings.rutServiciosAPL + '/api/campaniasDescuentosDestinos/';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listadoCampanias() {
    return this.httClient.get( this.rutServicioCampania ).pipe( map( res => res as CampaniaDescuentoDestino[] ) );
  }

  listadoCampaniasHabilitadas() {
    return this.httClient.get( this.rutServicioCampania + 'enabled' ).pipe( map( res => res as CampaniaDescuentoDestino[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicioCampania + id ).pipe( map( res => res as CampaniaDescuentoDestino ) );
  }

  obtenerPorCampania( id: string ) {
    return this.httClient.get( this.rutServicioCampania + 'campania/' + id ).pipe( map( res => res as CampaniaDescuentoDestino[] ) );
  }

  crear( campania: CampaniaDescuentoDestino ) {
    campania.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicioCampania, campania ).pipe( map( res => res as CampaniaDescuentoDestino ) );
  }

  actualizar( campania: CampaniaDescuentoDestino ) {
    campania.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicioCampania, campania ).pipe( map( res => res as any ) );
  }


}
